import React from 'react';

import { TypographyTable } from '../index';

const codeValues = [
  {
    previewText: 'Aa',
    tokenName: 'font.code',
    propValue: 'code',
    // NOTE: This assumes 14px "parent" font size, which if used inline with `font.body` is correct.
    // 0.875 * 14 = 12.25. In Figma this is 12px.
    fontSize: '0.875 em / 12.25 px*',
    lineHeight: '1*',
    fontWeight: 400,
  },
];

/**
 * __Typography code table__
 */
export const TypographyCodeTable = () => {
  return (
    <TypographyTable
      values={codeValues}
      testId="typography-code-table"
    />
  );
};
